import request from '../request';

export default {
  getIconos: () => {
    return request.get('icono');
  },
};
